import request from "@/utils/request";
const { ElMessage } = require("element-plus");

// 楼栋类型判断：1-4栋为小房间，5-6栋为大房间
function getRoomTypeByBuildId(buildId) {
  if (!buildId) return '未知';
  const id = Number(buildId);
  if (id >= 1 && id <= 4) return '小房间';
  if (id >= 5 && id <= 6) return '大房间';
  return '其他';
}

export default {
  name: "ApplyChangeRoom",
  data() {
    return {
      loading: true,
      dialogVisible: false,
      detailDialog: false,
      search: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      detail: {},
      isMobile: false,
      user: {},
      room: {
        dormRoomId: '',
        dormBuildId: '',
      },
      form: {
        username: '',
        name: '',
        oldDormBuildId: '',
        oldDormRoomId: '',
        reasonType: '房间设施问题',
        targetRoomType: '',
        reason: '',
      },
      rules: {
        reasonType: [{ required: true, message: "请选择调宿类型", trigger: "change" }],
        targetRoomType: [{ required: true, message: "请选择期望房型", trigger: "change" }],
        reason: [{ required: true, message: "请输入申请理由", trigger: "blur" }],
      },
    };
  },
  computed: {
    currentRoomType() {
      return getRoomTypeByBuildId(this.form.oldDormBuildId);
    },
    currentRoomTypeLabel() {
      const type = this.currentRoomType;
      if (type === '小房间') return '小房间（1-4栋，15㎡，无阳台）';
      if (type === '大房间') return '大房间（5-6栋，25㎡，有阳台）';
      return type;
    },
    isCrossTypeForm() {
      // 小房间 → 大房间 需审批
      return this.currentRoomType === '小房间' && this.form.targetRoomType === '大房间';
    },
  },
  created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    this.init();
    this.load();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    init() {
      try {
        this.user = JSON.parse(sessionStorage.getItem("user")) || {};
      } catch (e) {
        this.user = {};
      }
      this.form.username = this.user.username || '';
      this.form.name = this.user.name || '';
      this.getRoomInfo();
    },
    getRoomInfo() {
      if (!this.form.username) return;
      request.get("/room/getMyRoom/" + this.form.username).then((res) => {
        if (res.code === "0" && res.data) {
          this.room = res.data;
          this.form.oldDormBuildId = res.data.dormBuildId;
          this.form.oldDormRoomId = res.data.dormRoomId;
          // 自动设置期望房型为当前同类型
          this.form.targetRoomType = getRoomTypeByBuildId(res.data.dormBuildId);
        }
      });
    },
    async load() {
      this.loading = true;
      try {
        const res = await request.get("/applyChangeRoom/find/" + (this.user.name || ''), {
          params: {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            search: this.search,
          },
        });
        this.tableData = (res.data.records || []).map(r => ({
          ...r,
          currentRoomType: getRoomTypeByBuildId(r.oldDormBuildId),
        }));
        this.total = res.data.total || 0;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    isCrossType(row) {
      // 小房间 → 大房间 需审批
      return getRoomTypeByBuildId(row.oldDormBuildId) === '小房间' && row.targetRoomType === '大房间';
    },
    filterTag(value, row) {
      return row.state === value;
    },
    showDetail(row) {
      this.detail = {
        ...row,
        currentRoomType: getRoomTypeByBuildId(row.oldDormBuildId),
      };
      this.detailDialog = true;
    },
    closeDetails() {
      this.detailDialog = false;
    },
    add() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
        this.form.username = this.user.username || '';
        this.form.name = this.user.name || '';
        this.form.oldDormBuildId = this.room.dormBuildId || '';
        this.form.oldDormRoomId = this.room.dormRoomId || '';
        this.form.reasonType = '房间设施问题';
        this.form.targetRoomType = getRoomTypeByBuildId(this.room.dormBuildId);
        this.form.reason = '';
      });
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        try {
          const res = await request.post("/applyChangeRoom/add", this.form);
          if (res.code === "0") {
            ElMessage({ message: "申请提交成功，请等待管理员分配房间", type: "success" });
            this.search = "";
            this.load();
            this.dialogVisible = false;
          } else {
            ElMessage({ message: res.msg || "提交失败", type: "error" });
          }
        } catch (e) {
          ElMessage({ message: "网络错误", type: "error" });
        }
      });
    },
    cancel() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.dialogVisible = false;
    },
    formatRoomLabel(buildId, roomId) {
      if (buildId && roomId) {
        return buildId + '栋 - ' + roomId + '号房';
      }
      return '未分配';
    },
    getReasonTypeTag(type) {
      if (type === '单独住宿') return 'danger';
      if (type === '环境问题') return 'warning';
      return 'success';
    },
    getStateTagType(state) {
      if (state === '已通过') return 'success';
      if (state === '已拒绝') return 'danger';
      return 'info';
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.load();
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    },
  },
};
